import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import Author from "./Author";
import "../index.css";
import { useEffect } from "react";
import { getGamesData, getProfile } from "../redux/asyncThunk/userActions";

export default function Dashbord() {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.user?.status);
  const user = useSelector((state) => state.user?.data?.user);

  useEffect(() => {
    if (user?.id) {
      dispatch(getGamesData({ id: user.id }));
      dispatch(getProfile({ id: user.id }));
    }
  }, [dispatch, user.id]);

  return (
    <div>
      <div
        style={{ display: "flex", justifyContent: "center", padding: "10px 0" }}
      >
        <h1>Рабочий стол</h1>
      </div>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            height: "90vh",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <Author />
      )}
    </div>
  );
}
